module.exports = __webpack_public_path__ + "img/hm-section-one.1a0eac04.png";